<template>
  <div class="saddApp" :style="'height:'+curHeight+'px;background:url('+bg+') no-repeat;background-size:100% 100% !important;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px;"></div>
    <div class="shop">
      <ul>
        <li><font>收货人<i style="opacity: 0;">手</i></font><input type="text" placeholder="请输入收货人"/></li>
        <li><font>手机号码</font><input type="text" placeholder="请输入手机号码"/></li>
        <li><font>详细地址</font><input type="text" placeholder="请输入详细地址"/></li>
        <li><font>默认地址</font><el-radio v-model="radio" label="1">是</el-radio><el-radio v-model="radio" label="2">否</el-radio></li>
      </ul>
    </div>
    <a class="shadd">保存并使用</a>
    
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        bg:require('../../assets/images/farm.png'),
        radio: '2'
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .saddApp{
    max-width:640px;
    margin:0 auto;
    background-size: 100% 100%;
    overflow-y: scroll;
  }

  .saddApp .shop{
    width:92%;
    display:block;
    background:rgba(255,255,255,.8);
    margin:0px auto;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
  }
  .saddApp .shop ul{
    display:block;
    width:92%;
    margin:0 auto;
    padding-bottom:15px
  }
  .saddApp .shop ul li{
    padding:20px 0;
    color:#666;
    font-size:15px;
    border-bottom:solid 1px #EBF2FF;
  }
  .saddApp .shop ul li:last-child{
    border-bottom:none;
  }
  .saddApp .shop ul li font{
    padding-right:20px;
    color:#999
  }
  .saddApp .shop ul li input{
    border:none;
    background:none;
    width:70%;
    outline:none;
    font-size:15px;
  }
  .saddApp .shadd{
    height: 45px;
    background: #00D138;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 45px;
    width:92%;
    margin:0px auto;
    text-align:center;
    line-height: 45px;;
    color:#fff;
    font-size:16px;
    display:block;
    margin-top:50px
  }

</style>